
import React, { useState } from 'react';
import '../../styles/Footer.css';

const Footer = () => {

    const currentYear = new Date().getFullYear();

    return (
        <footer>
            <div className="footer-bottom">
                <p>Our resume builder is powered by Venus Online Software Training.</p>
                <p>&copy; {currentYear} All Rights Reserved.</p>
            </div>
        </footer>
    );
};

export default Footer;
